
$(document).ready(function () {
    
     //Go to Lead-step 2
    //  $(document).on('click', '#lead-next-step-2', function (e) {
    //     let button = $(this);
    //     button.attr('disabled', true);
    //     button.find('.fa').hide();
    //     button.find('.fa-spinner').show();

    //     let form = $('#step-1-form');
    //     let action = form.attr('action');
    //     let formData = new FormData(form[0]);
    //     formData.append('start_date', lead_date.start);
    //     formData.append('end_date', lead_date.end);
    //     // let formData = {
    //     //     market_id: $("#lead-market-id").val(),
    //     //     client_id: $("#lead-client-id").val(),
    //     //     start_date: lead_date.start,
    //     //     end_date: lead_date.end,
    //     // };


    //     $.ajax({
    //         type: 'POST',
    //         url: action,
    //         enctype: 'multipart/form-data',
    //         data: formData,
    //         processData: false,
    //         contentType: false,
    //         cache: false,

    //         success: function (data) {
    //             if (data.success) {
    //                 $('#step-1-errors').hide(200);
    //                 $('#step-2-errors').hide(200);
    //                 $('#step-2-tab').tab('show');

    //                 // //Range Picker for step two
    //                 // new Lightpick({
    //                 //     field: document.getElementById('look-back-date-start'),
    //                 //     secondField: document.getElementById('look-back-date-end'),
    //                 //     singleDate: false,
    //                 //     format: 'MM/DD/YYYY',
    //                 //     onSelect: function (start, end) {
    //                 //         look_back_date.start = start ? start.format('DD-MM-YYYY') : null;
    //                 //         look_back_date.end = end ? end.format('DD-MM-YYYY') : null;
    //                 //     }
    //                 // });

    //                 // sheet_id = data["sheet_id"];
    //                 client = data["client"];
    //                 market = data["market"];
    //                 start_date = data["start_date"];
    //                 end_date = data["end_date"];

    //                 // sheet.header = data["header"];
    //                 // sheet.rows = data["rows"];

    //                 let messages = [];
    //                 if (client) {
    //                     messages.push(`Selected Client is ${client["client_name"]} (${client["client_id"]})`);
    //                 }
    //                 if (market) {
    //                     messages.push(`Selected Market ID is ${market["market_id"]}`);
    //                 }
    //                 if (start_date ) {
    //                     messages.push(`Start Date: ${start_date}. End Date: ${end_date}`);
    //                 }
    //                 if (messages.length > 0) {
    //                     $('#step-2-messages').html(messages.join('<br>')).fadeIn();
    //                 }
    //             } else {
    //                 $('#step-1-errors').html(data["errors"].join('<br>')).fadeIn();
    //                 if (data["error_code"] === "google_auth") {
    //                     $('#google_login_button').show();
    //                     $('#next-step-2').hide();
    //                 }
    //             }

    //             button.attr('disabled', false);
    //             button.find('.fa').show();
    //             button.find('.fa-spinner').hide();
    //         },
    //         error: function () {
    //             button.attr('disabled', false);
    //             button.find('.fa').show();
    //             button.find('.fa-spinner').hide();
    //         }
    //     });
    // });



});
